import Upload from './upload';

export default Upload;

export {
  UploadProps,
  UploadListProps,
  UploadItem,
  UploadInstance,
  UploadStatus,
  RequestOptions,
  UploadRequestReturn,
} from './interface';
